// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MineButton_wrap__Tf9Sx","button":"MineButton_button__Yu5O0","animation":"MineButton_animation__3BnUB","animationCounter":"MineButton_animationCounter__1LBw8"};